import React, { useEffect, useState } from 'react'
import { Category } from '../common/Category/Category'
import { ListCheck } from '../../icons/ListCheck'
import { UtensilsCrossed4 } from '../../icons/UtensilsCrossed4'
import { CableCar3 } from '../../icons/CableCar3'
import { CalendarHeart } from '../../icons/CalenderHeart'
import { ActivityType } from '../common/ActiviltyIcons/ActivityType'
import { Bookmark } from '../common/BookMarkIcons/Bookmark'
import { Bookmark3 } from '../../icons/Bookmarks3'
import { Navigation4 } from '../../icons/Navigation4'
import SingleCardNew from '../common/SingleCardNew'
import CloseButton from '../common/CloseButton'
import NewFilter from '../common/Filters/NewFilter'
import Spinner from '../spinner/Spinner'
import NoDataFoundSmall from '../common/NoDataFoundSmall'
import { useLocation } from 'react-router'
import FavoritesGrid from '../Trip/FavoritesGrid'
import configs from '../../contentConfig'

const cardTypes = configs?.cards?.cardTypes || ["single", "grid"];
const allowGridCard = cardTypes.includes("grid");

const UI = ({name,
  parentDivClass="",
  path,
  data=[],
  closeModal,
  showCloseButton,
  isFilter=true,
  heading="",
  scrollRef=null,
  setData,
  noData,
  setNoData,
  setIsLoading,
  isloading,
  url,
  showHeader=false,
  showBookMark,
  filterType,
  selectedFilterRef=null,
  description="",
  showTotalItems=false,
  showDescription=false}) => {

  const totalItems = data?.length || 0;
  return (
    <div className={`${noData ?"no-parent-container" : ""} w-[100vw] max-w-[1000px] mx-auto flex flex-col items-start gap-10 pt-[30px] pb-[100px] px-0 relative bg-[#F6F3EA] ${parentDivClass || "overflow-hidden"}`}>
    {
      showCloseButton && <CloseButton onClick={closeModal}/>
    }
  {/* {
    isFilter &&   <div className="flex flex-col items-start gap-4 px-4 py-0 relative w-[100%] mx-1">
    
      
    <NewFilter data={data} filterType={filterType} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} setData={setData} setNoData={setNoData} isloading={isloading} setIsLoading={setIsLoading} url={url}/>

  </div>
  } */}
    
    
    {isloading ? (
      <div className="w-full flex justify-center items-center py-10 min-h-[50vh]">
        {/* <Spinner /> */}
      </div>
    ) :
  
     noData ? <>
     {/* <NoDataFoundSmall/> */}
     </>   :

     <div ref={scrollRef} className="flex flex-col items-start gap-6 px-4 py-0 self-stretch w-full relative flex-[0_0_auto]">
      <div>
     <div className="flex items-end justify-between relative self-stretch w-full flex-[0_0_auto]">
      {
     showHeader &&  name &&  <div class="h-8 w-[94px]">
       <span class="my-favorites-header text-[var(--wwwstanfordcourtcomblack)] font-bebas text-[32px] font-normal leading-8 tracking-normal whitespace-nowrap text-center">
         {name}
       </span>      
     </div>
      }
                

       {/* <div className="relative w-fit [font-family:'SF_Pro_Display-Regular',Helvetica] font-normal text-[#666666] text-sm tracking-[0] leading-[16.1px] whitespace-nowrap">
         See all
       </div> */}
     </div>
     {showTotalItems && <div className='ui-subtitle ui-total-items'> {totalItems} items</div> }
     {showDescription && <div className='ui-subtitle ui-description'>{description}</div>}
     </div>
     <div className='UI-cards-container max-sm:justify-between w-full flex max-[500px]:flex-col max-[500px]:flex-nowrap max-[500px]:gap-6 max-[632px]:gap-2 max-[765px]:gap-y-6  gap-6 flex-row flex-wrap'>
{
     data?.map((e,i)=>(
      (allowGridCard && e.images?.length >1) ? (
        <FavoritesGrid key={i} placeName={e.name} data={e} placeType={e.display_category?.label} rating={e.rating} timings='' price='' images={e.images} />
      ): (
       <SingleCardNew key={i} data={e}  size={"full"} boxHeight={"314px"} type={e.type} showBookMark={showBookMark}/>
      )
     ))
   }
   </div>

   </div>
  
}
    
          {/* <div className="flex flex-col items-center justify-center gap-2 self-stretch w-full relative flex-[0_0_auto]">
            <Button className="!flex-[0_0_auto]" text="Show all events" />
          </div> */}
    
  
    
     
        </div>
  )
}

export default UI
